// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__12zi1","footer":"ModalFilter_footer__3s6M8"};